module.exports = {"370304001":"城东街道","370304002":"城西街道","370304004":"山头街道","370304102":"域城镇","370304103":"白塔镇","370304106":"八陡镇","370304108":"石马镇","370304111":"源泉镇","370304112":"池上镇","370304113":"博山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370304.json
// module id = 1272
// module chunks = 0